import {
  GridIcon,
  PhotoLibraryIcon,
  ExpandIcon,
  CropIcon,
} from '@/components/icons';
import { useViewOptionsBarStyles } from './styles';

type ViewSize = 'small' | 'medium' | 'large';

interface ViewOptionsBarProps {
  rightPanelTab: 'presets' | 'creations';
  setRightPanelTab: (tab: 'presets' | 'creations') => void;
  viewCrop: boolean;
  setViewCrop: (crop: boolean) => void;
  viewSize: ViewSize;
  setViewSize: (size: ViewSize) => void;
}

export const ViewOptionsBar = ({
  rightPanelTab,
  setRightPanelTab,
  viewCrop,
  setViewCrop,
  viewSize,
  setViewSize,
}: ViewOptionsBarProps) => {
  const classes = useViewOptionsBarStyles();

  return (
    <div className={classes.tabHeader}>
      <button
        type="button"
        className={`${classes.tabButton} ${
          rightPanelTab === 'presets' ? classes.tabButtonActive : ''
        }`}
        onClick={() => setRightPanelTab('presets')}
      >
        <GridIcon className={classes.tabIcon} />
        Presets
      </button>
      <button
        type="button"
        className={`${classes.tabButton} ${
          rightPanelTab === 'creations' ? classes.tabButtonActive : ''
        }`}
        onClick={() => setRightPanelTab('creations')}
      >
        <PhotoLibraryIcon className={classes.tabIcon} />
        My Creations
      </button>

      <div className={classes.viewOptions}>
        <button
          type="button"
          className={`${classes.viewOptionButton} ${
            viewCrop ? classes.viewOptionButtonActive : ''
          }`}
          onClick={() => setViewCrop(!viewCrop)}
          title={viewCrop ? 'Show natural aspect ratio' : 'Crop to squares'}
          aria-label={
            viewCrop ? 'Show natural aspect ratio' : 'Crop to squares'
          }
        >
          {viewCrop ? (
            <ExpandIcon className={classes.viewOptionIcon} />
          ) : (
            <CropIcon className={classes.viewOptionIcon} />
          )}
        </button>

        <div className={classes.viewOptionsDivider} />

        {(['small', 'medium', 'large'] as const).map((size) => (
          <button
            key={size}
            type="button"
            className={`${classes.viewOptionButton} ${
              viewSize === size ? classes.viewOptionButtonActive : ''
            }`}
            onClick={() => setViewSize(size)}
            title={
              size === 'small'
                ? 'Small (more items)'
                : size.charAt(0).toUpperCase() + size.slice(1)
            }
            aria-label={`${size.charAt(0).toUpperCase() + size.slice(1)} view`}
          >
            <span className={classes.viewSizeText}>
              {size[0].toUpperCase()}
            </span>
          </button>
        ))}
      </div>
    </div>
  );
};
